<template>
  <div>
    <div class="container-fluid p-0" v-if="etapaForm != 3">
      <div class="row g-0">
        <div class="col-12" :style="'height:' + screenWidth + 'px'">
          <div class="bg-overlay-ago opacity-25"></div>
          <div
            class="d-flex justify-content-center w-100"
            style="margin-top: 3%"
          >
            <div class="d-flex flex-column" v-if="statusReuniao">
              <div class="text-center mb-3" style="align-self: center">
                <img
                  src="https://unicampo.coop.br/uploads/bkp/2022/portal/logo.png"
                  height="80"
                />
                <div
                  class="mb-3 mt-3 text-center"
                  style="
                    background-color: #07331a;
                    border-radius: 10px;
                    padding: 2px;
                    width: 650px;
                  "
                >
                  <h2 style="color: white" class="mt-2">
                    {{ dadosReuniao.nm_tipo_reuniao }}
                  </h2>
                </div>
              </div>

              <div class="col-12">
                <div class="row mb-2">
                  <div class="col-1" style="text-align: end">
                    <i class="mdi mdi-calendar-blank-outline font-size-reu" />
                  </div>
                  <div class="col-11 p-0 mt-2" style="font-size: 14px;">
                    <label>{{
                      this.$tools.converteData(dadosReuniao.dt_reuniao)
                    }}</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-1" style="text-align: end">
                    <i class="mdi mdi-map-marker-outline font-size-reu" />
                  </div>
                  <div class="col-11 text-center-reu p-0 mt-2" style="font-size: 14px;">
                    <label>{{ dadosReuniao.nm_localidade }}</label>
                  </div>
                </div>
              </div>

              <div
                v-if="etapaForm == 1"
                class="d-flex mt-4 justify-content-center w-100"
              >
                <b-form-group
                  label="Para confirmar sua presença, digite seu CPF:"
                  class="fs-2 text-center"
                >
                  <b-form-input
                    v-model="cpf"
                    class="fs-2 text-center"
                    v-mask="'###.###.###-##'"
                    v-on:keyup.enter="validaForm()"
                    placeholder="Digite Aqui"
                    inputmode="numeric"
                    style="font-size: 18px!important"
                  />
                </b-form-group>
              </div>

              <div
                v-if="etapaForm == 2"
                class="d-flex flex-column mt-4 align-items-center"
              >
                <label class="fs-1">
                  Olá <strong>{{ dadosCoop.nmRazao }}</strong
                  >,
                </label>
                <b-form-group
                  label="confirme sua cidade de partida:"
                  class="text-center fs-2 assembleiaMultiselect"
                  style="width: 75% !important"
                  :invalid="!isRegiaoSelected"
                >
                  <multiselect
                    v-model="regiao"
                    placeholder="Selecione"
                    :show-labels="false"
                    :allow-empty="false"
                    :options="optionCidade"
                    label="cidade_uf"
                    class="text-center"
                    style="font-size: 20px"
                  />
                </b-form-group>
              </div>

              <div class="d-flex mt-3 justify-content-center w-100">
                <button
                  class="btn btn-success mt-3 p-0"
                  style="width: 25%"
                  @click="validaForm()"
                  :disabled="loading"
                >
                  <label
                    style="
                      margin-right: 10px;
                      font-size: 25px;
                      vertical-align: super;
                    "
                  >
                    Avançar
                  </label>
                  <i class="mdi mdi-cursor-pointer font-size-reu icon-pisca" />
                  <b-spinner small class="ms-2" v-if="loading"></b-spinner>
                </button>
              </div>
            </div>
            <div class="d-flex justify-content-center" v-else>
              <h3>Sem Reunião Aberta</h3>
            </div>
          </div>
        </div>
      </div>
      <footer>
        <div class="d-flex w-100 justify-content-center">
          <img :src="require(`@/assets/images/assembleia.png`)" height="350" />
        </div>
      </footer>
    </div>

    <div
      class="container-fluid p-0"
      :style="etapaForm == 3 ? '' : 'display:none'"
    >
      <div style="position: absolute">
        <video
          autoplay="true"
          playsInline="true"
          muted="true"
          id="video"
        ></video>
        <canvas :style="captura ? '' : 'display:none'" id="canvas"></canvas>
      </div>
      <!-- <div style="position: fixed; border: 30px solid grey; height: 100%; width: 100%"></div> -->
      <div
        style="
          position: fixed;
          border-width: 20px 20px 80px;
          border-style: solid;
          border-color: grey;
          border-image: initial;
          height: 100%;
          width: 100%;
        "
      >
        <div
          class="d-flex"
          :class="
            captura ? 'justify-content-between' : 'justify-content-center'
          "
          style="margin: 0 auto;top: 101%;position: relative; justify-content: center;"
        >
          <b-button
            v-if="captura"
            variant="danger"
            @click="cancelarCaptura()"
            class="mt-1"
            data-v-step="5"
            style="margin-right: 20px;"
          >
            Cancelar
          </b-button>
          <button
            type="button"
            class="btn btn-primary"
            style="
              width: 60px;
              height: 60px;
              border-radius: 100%;
              border-width: 4px;
              border-color: white;
            "
            @click="capturar()"
          ></button>
          <b-button
            v-if="captura"
            variant="success"
            @click="validaForm()"
            class="mt-1"
            data-v-step="5"
            style="margin-left: 20px;"
          >
            Avançar
          </b-button>
        </div>
      </div>
    </div>
    <b-modal v-model="showModal" size="lg" centered hide-header hide-footer>
      <div
        class="d-flex w-100 justify-content-center fs-4"
        v-if="loadingModal == 1"
      >
        <div>Processando</div>
        <b-spinner small class="ms-2 mt-2"></b-spinner>
      </div>
      <div class="d-flex flex-column w-100 fs-4 align-items-center" v-else>
        <div style="display: inline">{{ retorno }}</div>
        <div style="color: red; display: inline" v-if="apto == 'I'">
          Você não esta apto a votar
        </div>
        <div style="color: green; display: inline" v-else>
          Você esta apto a votar
        </div>
        <div>Aguarde a impressão do ticket</div>
      </div>
    </b-modal>

    <!-- end container-fluid -->
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
  },

  layout: "empty",
  data() {
    return {
      cpf: "",
      cpfSemMascara: "",
      regiao: "",
      isRegiaoSelected: false,
      optionCidade: [],
      etapaForm: 1,
      dadosCoop: {
        nmRazao: "",
      },
      dadosReuniao: {
        nm_localidade: "",
        hr_reuniao: "",
        sq_reuniao: "",
      },
      statusReuniao: false,
      showModal: false,
      fotoAux: require("@/assets/images/user.png"),
      loading: false,
      video: {},
      canvas: {},
      screenWidth: 0,
      captura: false,
      loadingModal: 1,
      retorno: "",
      apto: "",
    };
  },

  created() {
    this.screenWidth = window.screen.height - 511;
  },

  async mounted() {
    this.configurarLocalizacao();
    this.buscarReuniao();
    this.optionCidade = await this.$tools.filtroCooperado.buscarCidades();
    this.screenWidth = window.screen.height - 511;
    this.configurarCamera();
  },

  methods: {
    verificaCPF() {
      this.cpfSemMascara = this.cpf.replace(/\W/g, "");
      if (this.cpfSemMascara.length === 0) {
        return false;
      }
      if (
        this.cpfSemMascara == "00000000000" ||
        this.cpfSemMascara == "11111111111" ||
        this.cpfSemMascara == "22222222222" ||
        this.cpfSemMascara == "33333333333" ||
        this.cpfSemMascara == "44444444444" ||
        this.cpfSemMascara == "55555555555" ||
        this.cpfSemMascara == "66666666666" ||
        this.cpfSemMascara == "77777777777" ||
        this.cpfSemMascara == "88888888888" ||
        this.cpfSemMascara == "99999999999"
      ) {
        return false;
      } else {
        if (!this.validaCPF(this.cpfSemMascara)) {
          return false;
        } else {
          return true;
        }
      }
    },

    validaCPF(cpf) {
      var soma = 0;
      var resto;
      for (var i = 1; i <= 9; i++)
        soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
      resto = (soma * 10) % 11;
      if (resto == 10 || resto == 11) resto = 0;
      if (resto != parseInt(cpf.substring(9, 10))) return false;
      soma = 0;
      for (i = 1; i <= 10; i++)
        soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
      resto = (soma * 10) % 11;
      if (resto == 10 || resto == 11) resto = 0;
      if (resto != parseInt(cpf.substring(10, 11))) return false;

      return true;
    },

    buscarReuniao() {
      this.$http
        .get("api/reuniao/buscarReuniao")
        .then((response) => {
          if (response.data) {
            this.statusReuniao = true;
          }
          this.dadosReuniao = response.data;
        })
        .catch((err) => {
          console.log(err.response.data.message);
        });
    },

    sleep() {
      return new Promise((resolve) => {
        setTimeout(resolve, 5000);
      });
    },

    async validaForm() {
      if (this.etapaForm == 1) {
        await this.consultarCoop();
      } else if (this.etapaForm == 2) {
        if (!this.regiao) {
          // Se não foi selecionada, define isRegiaoSelected como false para exibir a mensagem de erro
          this.isRegiaoSelected = false;
          this.$tools.alerta("Selecione uma cidade!", "info");
          return;
        }
        this.isRegiaoSelected = true;
        this.etapaForm = 3;
      } else if (this.etapaForm == 3) {
        await this.registrarCoop();
      }
    },

    consultarCoop() {
      if (!this.verificaCPF(this.cpf)) {
        this.$tools.alerta("CPF invalido", "info");
        return;
      }
      this.loading = true;
      this.$http
        .get(
          "api/reuniao/validarPresenca/" +
            this.cpfSemMascara +
            "/" +
            this.dadosReuniao.sq_reuniao
        )
        .then((response) => {
          var result = response.data;
          this.loading = false;
          this.regiao = this.optionCidade.find(
            (el) => el.sq_regiao == result.sq_regiao
          );
          this.dadosCoop.nmRazao = result.nm_razao;
          this.etapaForm = 2;
        })
        .catch((err) => {
          this.$tools.alerta(err.response.data.message, "info");
          this.loading = false;
        });
    },

    registrarCoop() {
      this.etapaForm = 1;
      this.loadingModal = 1;
      this.showModal = true;
      let headers = {
        sistema: "Portal",
        plataforma: this.$tools.getBrowser()[0],
        versao: this.$tools.getBrowser()[1],
        ip: this.$store.state.ip,
        modulo: "/assembleia",
      };

      if (window.latLng) {
        headers.lat = window.latLng.lat;
        headers.lng = window.latLng.lng;
      }

      this.$http
        .post(
          "api/reuniao/registrarPresenca",
          {
            cpf: this.cpfSemMascara,
            sqReuniao: this.dadosReuniao.sq_reuniao,
            sqRegiao: this.regiao.sq_regiao,
            arquivo: this.canvas.toDataURL(),
            impressora: this.$route.params.id,
          },
          { headers }
        )
        .then(async (response) => {
          var result = response.data;
          this.cpf = "";
          this.regiao = "";
          this.captura = false;
          this.loadingModal = 2;
          this.retorno = result.retorno;
          this.apto = result.apto;
          await this.sleep();
          this.showModal = false;
        })
        .catch((err) => {
          this.$tools.alerta(err.response.data.message, "error");
          this.loading = false;
          this.showModal = false;
          this.cpf = "";
          this.regiao = "";
          this.captura = false;
        });
    },

    capturar() {
      this.canvas = document.querySelector("#canvas");
      this.canvas.width = this.video.videoWidth;
      this.canvas.height = this.video.videoHeight;
      this.canvas
        .getContext("2d")
        .drawImage(
          this.video,
          0,
          0,
          this.video.videoWidth,
          this.video.videoHeight
        );
      this.captura = true;
    },

    cancelarCaptura() {
      this.captura = false;
    },

    configurarLocalizacao() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          function (position) {
            window.latLng = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
          },
          function (error) {
            alert(
              "Erro ao obter localização! Para nos ajudar e melhorar o sistema habilite a localização"
            );
            console.log("Erro ao obter localização.", error);
          }
        );
      } else {
        console.log("Navegador não suporta Geolocalização!");
      }
    },

    async configurarCamera() {
      const constraints = {
        video: {
          width: window.screen.height - 100,
          height: window.screen.width - 20,
        },
      };
      this.video = document.querySelector("#video");
      await navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          this.video.srcObject = stream;
        })
        .catch((error) => {
          alert("Erro ao acessar a câmera:", error);
        });
    },
  },
};
</script>
<style>
#video {
  position: absolute;
}

#canvas {
  position: relative;
}

.bg-overlay-ago {
  background-color: white;
}

.display-full {
  display: -ms-flexbox;
  display: flex;
}
.div-center {
  width: 330px;
  top: 16%;
  left: 39%;
  position: absolute;
}

.text-center-reu {
  font-size: 12px;
}

.font-size-reu {
  font-size: 26px;
  color: #07331a;
}

.assembleiaMultiselect .multiselect,
.assembleiaMultiselect .multiselect__input,
.assembleiaMultiselect .multiselect__single {
  font-size: 25px !important;
}

@keyframes icon-pisca {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
.icon-pisca {
  color: white;
  -webkit-animation: icon-pisca 0.9s linear infinite;
  -moz-animation: icon-pisca 0.9s linear infinite;
  -ms-animation: icon-pisca 0.9s linear infinite;
  -o-animation: icon-pisca 0.9s linear infinite;
  animation: icon-pisca 0.9s linear infinite;
}
</style>
